<template>
  <div v-if="!loading">
    <div class="card px-3">
      <div class="card-header">
        <h4 class="card-title">Team: {{ team.name }}</h4>
      </div>
      <div class="card-body pt-0">
        <div class="card-text spaced-rows border-bottom-rows py-3">
          <div class="row">
            <div class="col-3 font-weight-bold">Team Id</div>
            <div class="col-9">{{ team.id }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Team Name</div>
            <div class="col-9">{{ team.name }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Team Slug</div>
            <div class="col-9">{{ team.slug }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Team Owner</div>
            <div class="col-9">
              <div>{{ `${team.owner.full_name} (${team.owner.id})` }}</div>
              <div class="text-muted">{{ team.owner.email }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Agency</div>
            <div class="col-9">{{ team.is_agency ? "Yes" : "No" }}</div>
          </div>
        </div>
        <div class="text-right pt-2">
          <router-link
            :to="{ name: 'edit-team', params: { teamId: team.id } }"
            class="btn btn-primary"
          >
            Edit team
          </router-link>
        </div>
      </div>
    </div>
    <div class="card px-3">
      <div class="card-header">
        <h4 class="card-title">Stripe Informations</h4>
      </div>
      <div class="card-body pt-0">
        <div class="card-text spaced-rows border-bottom-rows py-3">
          <div class="row">
            <div class="col-3 font-weight-bold">Customer Id</div>
            <div class="col-9">{{ team.stripe_customer_id }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Subscription Id</div>
            <div class="col-9">{{ team.stripe_subscription_id }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Subscription Status</div>
            <div class="col-9">{{ team.subscription_status }}</div>
          </div>
          <div class="row" v-if="team.subscription_status === 'canceled'">
            <div class="col-3 font-weight-bold">Cancel Subscription At</div>
            <div class="col-9">{{ team.cancel_subscription_at }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Interval</div>
            <div class="col-9">{{ team.stripe_interval }}</div>
          </div>
          <div v-for="(price, index) in team.prices" :key="index" class="row">
            <div class="col-3 font-weight-bold">
              Diffusion Pricing ({{ price.stripe_interval }})
            </div>
            <div class="col-9">{{ price.amount / 100 }} $</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card px-3" v-if="team.products.length">
      <div class="card-header">
        <h4 class="card-title">Team products</h4>
      </div>
      <div class="card-body pt-0">
        <div class="card-text py-3">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">name</th>
                <th scope="col">in_subscription</th>
                <th scope="col">active</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, index) in team.products" :key="index">
                <td scope="row">{{ product.name }}</td>
                <td>{{ product.pivot.in_subscription }}</td>
                <td>{{ product.pivot.is_active }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card px-3" v-if="canSyncSubscription">
      <div class="card-header">
        <h4 class="card-title">Sync Stripe Subscription</h4>
      </div>
      <div class="card-body">
        <SyncStripeSubscriptionForm :teamId="team.id" />
      </div>
    </div>
  </div>
</template>

<script>
import SyncStripeSubscriptionForm from "@/components/Teams/SyncStripeSubscriptionForm.vue";
export default {
  components: {
    SyncStripeSubscriptionForm
  },
  props: {
    teamId: {
      required: true,
      type: [String, Number]
    }
  },
  data() {
    return {
      team: {},
      loading: false
    };
  },
  async created() {
    this.loading = true;
    await this.$http
      .get(`/enroll_admin/teams/${this.teamId}`)
      .then(({ data }) => {
        this.team = data;
      });
    this.loading = false;
  },
  computed: {
    canSyncSubscription() {
      return (
        (this.team.products.length === 0 &&
          this.team.subscription_status === "none") ||
        this.team.subscription_status === "canceled"
      );
    }
  }
};
</script>
